import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import React, { Fragment } from "react";
import RecordingIco from "../../../../assets/icons/RecordingIco";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import NoteBackgroundImg from "../../../../assets/images/note-background.png";
import CommonButton from "../../../../component/Button";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import CommonTextField from "../../../../component/Input";

function AddNote({
  openNoteDialog,
  handleCloseNoteDialog,
  handleCreateNote,
  notes,
}) {
  const validationSchema = Yup.object().shape({
    notes: Yup.string().required("Note is required"),
  });

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={openNoteDialog}
      sx={{
        "& .MuiDialog-paper": {
          overflow: "hidden",
          borderRadius: "10px",
        },
      }}
    >
      <img
        src={NoteBackgroundImg}
        style={{ position: "absolute", width: "max-content", opacity: "0.7" }}
      />
      <DialogActions>
        <Button onClick={handleCloseNoteDialog}>
          <XCloseIco />
        </Button>
      </DialogActions>
      <DialogTitle>
        <Typography variant="h3" sx={{ mt: 2 }}>
          {notes.noteData?.id ? "Update Note" : "Create Note"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            notes: notes?.noteData.note || "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleCreateNote(values.notes);
          }}
        >
          {({ values, errors, touched, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Grid2 spacing={2} container>
                <Fragment>
                  <Grid2 size={12}>
                    <Typography variant="body1" marginBottom={"10px"}>
                      Note
                    </Typography>

                    <CommonTextField
                      id="outlined-multiline-static"
                      placeholder="Enter the notes..."
                      multiline
                      rows={4}
                      value={values.notes}
                      padding={"0px"}
                      onChange={(e) => setFieldValue("notes", e.target.value)}
                      error={touched.notes && Boolean(errors.notes)}
                      helperText={touched.notes && errors.notes}
                      fullWidth
                    />
                  </Grid2>

                  <Grid2 size={12}>
                    <CommonButton
                      variant="outlined"
                      color="#344054"
                      border="#D0D5DD"
                      fontWeight="600"
                      padding="10px"
                      value={notes.noteData?.id ? "Start Recording" : "Record"}
                      startIcon={<RecordingIco />}
                      gap={"0px"}
                      disabled
                      width={"100%"}
                    />
                  </Grid2>

                  <Grid2 size={12}>
                    <CommonButton
                      variant="outlined"
                      color="#344054"
                      border="#D0D5DD"
                      fontWeight="600"
                      padding="10px"
                      type="submit"
                      value={notes.noteData?.id ? "Update" : "Create Note"}
                      loading={notes.btnLoading}
                      disabled={notes.btnLoading}
                      width={"100%"}
                    />
                  </Grid2>
                </Fragment>
              </Grid2>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}

export default AddNote;
